<template>
  <v-card class="d-flex flex-column my-4">
    <div class="pa-3 border-bottom" style="background-color: #f2f2f2;">
      <h3>WaizmannTabelle</h3>
    
      <h2>Im Praxiseinsatz</h2>
    </div>
    
    <div class="pa-4 image-container">
      <img
        :src="require('@/assets/wallaufsteller/' + content.cont_image)"
        class="text-white centered-image"
        height="400"
      />
    </div>
  

  </v-card>
</template>

<script setup>
import { defineProps } from "vue";
const props = defineProps({
  content: {
    type: Object,
    required: true
  }
});
console.log(props.content.cont_id)


</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #088a85;
}

.text-primary {
  color: #088a85;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.centered-image {
  /* Optional: Zusätzliche Styling für das Bild */
  object-fit: contain;
}
</style>
